import React from 'react';
import irelandApi from '../irelandApi';
import {actions} from 'react-redux-form';
import ToastMessage from '../components/common/toast-message';
import {toast} from 'react-toastify';
import {history} from '../store';
import FileDownload from 'react-file-download'
import qs from 'qs';

export const getExpiry = () => (dispatch) => {
    dispatch({type: 'GET_POINTS_EXPIRY_PENDING', payload: []});
    //TODO: vegpont csere
    return irelandApi.get('/api/admin/point_expiry')
    .then(function (response) {
        dispatch({type: 'GET_POINTS_EXPIRY_FULFILLED', payLoad: response.data.data});
        dispatch(actions.change('deep.points_expiry', {
          "id": response.data.data.id,
          "day": response.data.data.attributes['day'],
          "month": response.data.data.attributes['month'],
      }))
    })
    .catch(function (error) {
        dispatch({type: 'GET_POINTS_EXPIRY_REJECTED', payLoad: error});
    });
};

export const saveExpiry = (payload) => {
    const data = {
      point_expiry: {...payload}
    };
    //TODO: vegpont csere
    return irelandApi.put(`/api/admin/point_expiry/${data.point_expiry.id}`, data)
                     .then((response) => {
                        toast.success(<ToastMessage
                            iconStyle="success"
                            message="Points has been saved successfully"/>);
                     })
                     .catch((error) => {
                       const data = {
                         ...error.response.data.errors
                       };
                       return Promise.reject(data);
                     })
  };

  export const getPointsTransactions = (pointsNumber, dateFrom, dateTo, pointsPot = [], page = '') => (dispatch) => {
    dispatch({
      type: "GET_POINTS_TRANSACTIONS_PENDING",
      payLoad: []
    });

    let q = {
      search: pointsNumber,
      points_date_from: dateFrom,
      points_date_to: dateTo,
      points_pot: pointsPot.map(option => option.value).join(',')
    };
    return irelandApi.get(`/api/admin/point_transactions?${qs.stringify({q: q}, {encodeValuesOnly: true})}&page=${page}`)
                     .then((response) => {
                       dispatch({
                         type: "GET_POINTS_TRANSACTIONS_FULFILLED",
                         payLoad: response.data
                       });
                     })
                     .catch((error) => {
                       dispatch({
                         type: 'GET_POINTS_TRANSACTIONS_REJECTED',
                         payLoad: error.data
                       })
                     })
  };

  export const getPointsDetails = (id) => (dispatch) => {
    dispatch({
      type: "GET_POINTS_DETAILS_PENDING",
      payLoad: []
    });
  
    return irelandApi.get(`/api/admin/point_transactions/new?customer_number=` + id)
                     .then((response) => {
                       dispatch({
                         type: "GET_POINTS_DETAILS_FULFILLED",
                         payLoad: response.data
                       });
                     })
                     .catch((error) => {
                       dispatch({
                         type: 'GET_POINTS_DETAILS_REJECTED',
                         payLoad: error.data
                       })
                     })
  };

  export const addManualPoints = (payload) => {
    const data = {
      user_point: {...payload}
  };
  return irelandApi.post('/api/admin/point_transactions', data)
                   .then((response) => {
                      toast.success(<ToastMessage
                          iconStyle="success"
                          message="Manual points transaction has been saved successfully"/>);
                        history.push('/admin/points-transactions');
                   })
                   .catch((error) => {
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
  };

  export const viewExpire = () => (dispatch) => {
    return irelandApi.get(`/api/admin/user_points_expired.csv`)
                     .then((response) => {
                       let filename = "points_expiry.csv";
                       FileDownload(response.data, filename);
                     })
                     .catch((error) => {
                       toast.error(<ToastMessage iconStyle="error" message={`Points expiry can not be downloaded: ${error.response.data.errors[0]}`}/>);
                     })
  };


// WEBPACK FOOTER //
// ./src/actions/points.js